<!-- the main view -->
<template>
  <v-container fluid class="ma-0 pa-0">
    <v-parallax src="../assets/blue-watercolor.jpg" width="100%" height="100%">
      <!-- introduction -->
      <about-me
        id="about"
        data-aos="zoom-in"
        data-aos-once="false"
        v-bind:about="about"
      />

      <introduction
        id="intro"
        data-aos="zoom-in"
        data-aos-once="false"
        v-bind:intro="intro"
      />

      <skills id="skills" v-bind:skills="skills" v-if="false" />

      <!-- carousel -->
      <carousel
        id="exp"
        v-bind:exps="exps"
        data-aos="zoom-in"
        data-aos-once="false"
      />

      <timeline id="timeline" v-if="false" />

      <!-- project tiles -->
      <projects
        id="projects"
        data-aos="fade-up"
        data-aos-once="false"
        v-bind:projects="projects"
        v-if="false"
      />

      <!-- contact details -->
      <contact
        id="contact"
        data-aos="zoom-in"
        data-aos-once="false"
        v-bind:contact="contact"
      />
    </v-parallax>
  </v-container>
</template>

<script>
import AboutMe from "./AboutMe.vue";
import Introduction from "./Introduction.vue";
import Skills from "./Skills.vue";
import Carousel from "./Carousel.vue";
import Projects from "./tiles/Projects.vue";
import Contact from "./Contact.vue";
import Timeline from "./timeline/Timeline.vue";
import me from "../assets/me.jpg";
import shopback from "../assets/shopback-icon.jpg";
import janestreet from "../assets/etc.jpeg";
import hacknroll from "../assets/hackandroll.png";
import salesforcedevcert from "../assets/salesforce-cert.png";
import ultrahackathon from "../assets/ultrahackathon.png";
import buildonasean from "../assets/buildonasean.png";
import circleslife from "../assets/circleslife.png";
import tiktoklogo from "../assets/tiktok-icon.jpg";

export default {
  components: {
    AboutMe,
    Introduction,
    Skills,
    Carousel,
    Projects,
    Contact,
    Timeline,
  },
  name: "MainPage",
  data: () => ({
    isActive: true,
    // ---- ABOUT SECTION ----
    about: {
      scroll: { next: "intro", prev: null },
      name: "ashleigh",
      content:
        "Hello, and welcome to my personal website! I am a software engineer at TikTok :)",
    },
    //  ----- PERSONAL INTRODUCTION -----
    intro: {
      scroll: { next: "exp", prev: "about" },
      img: me,
      heading: "A little more...",
      body: [
        "Proud mother of 2 lovebirds. Animal-lover. Coffee is a must.",
        "When not glued to the computer screen, you can find me glued to other screens. (please save my eyes!)",
        "An advocate for the color blue. Though I own a pink mouse and keyboard.",
        "",
        "",
      ],
      sidenote: [
        "This website was my first venture into web programming when I was an undergrad, powered by Vue and pieced together with components from Vuetify along with self-made components. I'm planning to do a little reworking to this website with my updated knowledge, so stay tuned :)",
      ],
    },
    // ----- SKILLS SECTION -----
    skills: {
      scroll: { next: "exp", prev: "intro" },
      programming: [
        { key: "javascript", val: 0.6 },
        { key: "python", val: 0.7 },
        { key: "java", val: 0.5 },
        { key: "golang", val: 0.9 },
      ],
      frameworks: [
        { key: "reactjs", val: 0.8 },
        { key: "vuejs", val: 0.7 },
        { key: "nodejs", val: 0.6 },
        { key: "flask", val: 0.5 },
        { key: "salesforce", val: 0.5 },
      ],
    },
    skills2: {},
    // ---- EXPERIENCE SECTION ----
    exps: {
      scroll: { next: "contact", prev: "intro" },
      content: [
         {
          title: "TikTok Live Money Platform",
          when: "2023 - 2024 (ongoing)",
          img: tiktoklogo,
          subtitle: "Backend Engineer",
          description:
            "I am a backend engineer at TikTok Live's Money Platform, and build and maintain the systems that pay all of our creators in many different ways at an unimaginable scale. Primarily using Golang, MySQL databases, HIVE tables and RocketMQ",
          link:
            "",
        },
        {
          title: "TikTok SG Engineering 48 Hour Hackathon",
          when: "2023",
          img: tiktoklogo,
          subtitle: "1st Runner's Up",
          description:
            "TikTok organised a 48 hour hackathon for its engineering team in Singapore. A little unhinged to participate in a hackathon as a full-time engineer with real work responsibilities - but the effort we poured into our product earned us 1st Runner's Up (and a coffee machine!)",
          link:
            "",
        },
        {
          title: "Build on Asean 2021",
          when: "2021",
          img: buildonasean,
          subtitle: "Champion",
          description:
            "A hackathon hosted by Amazon Web Services and held across 5 different countries in Southeast Asia. Click on the button below to check out my medium post on my experience!",
          link:
            "https://medium.com/@ashleighaathar/build-on-asean-2021-champions-team-clout9-6e69d6c77fc5",
        },
        {
          title: "Feature by NUS Computing on LinkedIn",
          embed:
            "https://www.linkedin.com/embed/feed/update/urn:li:share:6836550868792414208",
        },
        {
          title: "Circles.Life",
          when: "2021",
          img: circleslife,
          subtitle: "Software Engineer Intern",
          description:
            "I worked on both backend and frontend technologies at Circles, switching between Golang and Javascript and using MongoDB and RabbitMQ. 3 months in, I have successfully completed and released 5 projects to production, with many more to come!",
          link: "",
        },
        {
          title: "Shopee UltraHackathon",
          when: "2021",
          img: ultrahackathon,
          subtitle: "1st Runner's Up",
          description:
            "An intensive 36 hour hackathon organised by Shopee. Out of a total of 400 teams, we emerged 1st Runner's Up. Our product is an enhancement to Shopee's existing Rewards System, built with React Native and an Express backend.",
          link: "",
        },
        {
          title: "Hack & Roll 2021",
          when: "2021",
          img: hacknroll,
          subtitle: "Participant",
          description:
            "A 24 hour hackathon organised by NUS Computing Club. I developed a fun Android application integrating Spotify, and handled its design and animations.",
          link: "https://devpost.com/software/spotify-disco",
        },
        {
          title: "Jane Street ETC",
          when: "2020",
          img: janestreet,
          subtitle: "Participant",
          description:
            "A day-long programming contest where participants compete against each other in a simulated market. I worked on the main trading logic to simulate the process of buying and selling bonds and stocks in a market.",
        },
        {
          title: "Shopback Singapore",
          when: "2020",
          img: shopback,
          subtitle: "Salesforce Developer Intern",
          description:
            "I worked on Shopback's Salesforce platforms to help in designing and building an efficient Salesforce workflow for Shopback's multi-national business, graphic design and sales teams. Within 3 months, we delivered a working MVP to be released to the teams.",
          link: "",
        },
        // Qualifications
        {
          title: "Salesforce Developer Certification",
          img: salesforcedevcert,
          when: "2020",
          subtitle: "Platform Developer 1",
          description:
            "Due to COVID company policies, sponsorships were not as generously give out. I am honoured to have been an exception, and the only intern to receive sponsorship from Shopback to become a certified Salesforce developer.",
          link: "",
        },
      ],
    },
    // ---- TIMELINE SECTION -----
    timeline: {
      scroll: { next: "contact", prev: "exp" },
    },
    // ---- PROJECT TILE SECTION ----
    projects: {
      content: [
        // // this portfolio
        // {
        //   projTitle: "This Personal Website",
        //   projDes:
        //     "I built this personal website from scratch, making use of the official Vue.js cookbook and online reference.",
        //   projFrameworks: ["Vue.Js", "HTML/CSS", "JS"],
        // },
        // SPA from CS3203
        {
          projTitle: "Static Program Analyser",
          projDes:
            "A static program analyser (SPA) written in C++ and built around software engineering principles and object oriented programming. This SPA takes in the source program, store its attributes and parses and answer queries regarding the program.",
          // projSource: "https://github.com/nus-cs3203/team04-win-spa-20s1",
          projFrameworks: ["C++"],
        },
        // Duke todo list
        {
          projTitle: "CLI Task Manager",
          projDes:
            "A cute and lightweight Pokémon-themed command line interface (CLI) task manager based on the Duke software engineering template. Made using Java and JavaFx, and designed using object-oriented principles.",
          projSource: "https://github.com/airshhlay/duke",
          projFrameworks: ["Java", "JavaFx"],
        },
        // a-link-for-you
        // {
        //   projTitle: "Pesterer",
        //   projDes:
        //     "A small application written using Flask to send to friends when they have failed to meet up for awhile. Note: function to notify me on telegram has been disabled as I'm a little busy now.",
        //   projImgUrl:
        //     "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        //   projSource: "https://a-link-for-you.herokuapp.com",
        //   projFrameworks: ["Flask", "HTML", "CSS"],
        // },
        // sudoku solver
        {
          projTitle: "Sudoku A.I. Solver",
          projDes:
            "A simple sudoku solver that makes use of the backtracking algorithm with inference to solve 9x9 sudoku grids.",
          projSource: "https://github.com/airshhlay/sudoku-solver",
          projFrameworks: ["Python", "Artificial Intelligence"],
        },
        // random stock monitor
        {
          projTitle: "Random Stock Monitor",
          projSource: "https://github.com/airshhlay/random-stock-monitor",
          projFrameworks: ["Python", "Plotly Dash"],
          wordPressUrlSlug: "random-stock-monitor",
        },
        // quote collection
        // {
        //   projTitle: "Personal Quote Collection Site",
        //   projDes: "I built this for myself! I enjoy collecting meaningful quotes and wanted a way to display and look through them whenever I needed inspiration.",
        //   projFrameworks: ["Python", "Flask", "Vue.js"],
        //   sourceBtnName: "Github Link",
        //   locationBtnName: "Launch the App",
        // },

        // exercise tracker
        // {
        //   projTitle: "Exercise Logger",
        //   projDes: "A way to track your favourite youtube workouts and plan your exercise!",
        //   projFrameworks: ["React.js", "JavaScript"],
        // },

        // disco android app
        {
          projTitle: "Spotify Integrated Virtual Disco",
          projDes:
            "An android application whipped up in 24 hours for NUS Hack & Roll 2021. Makes use of the Spotify Web and SDK API to change the mood in the virtual disco according to the kind of song playing.",
          projSource: "https://devpost.com/software/spotify-disco",
          projFrameworks: ["Android"],
          sourceBtnName: "Devpost",
        },
      ],
    },
    // ---- CONTACT SECTION ----
    contact: {
      scroll: { prev: "exp", next: null },
      email: {
        display: "ashleighaathar@gmail.com",
        link: "mailto:ashleighaathar@gmail.com",
      },
      github: {
        display: "My Github",
        link: "https://github.com/airshhlay",
      },
      linkedin: {
        display: "My Linkedin Profile",
        link: "https://www.linkedin.com/in/ashleighaathar",
      },
      medium: {
        display: "My Medium Profile",
        link: "https://medium.com/@ashleighaathar"
      }
    },
  }),
};
</script>

<style>
/* Fonts */
@import url("https://fonts.googleapis.com/css2?family=Concert+One&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Avenir&display=swap");

/* About Section */
.about--text-name {
  font-family: "Concert One", cursive;
  /* color: rgb(220, 171, 209); */
  color: black;
  line-height: 1.2;
}

.about--text-body {
  font-family: "Avenir", cursive;
  line-height: 1.6;
  color: black;
  text-align: left;
}

.about--card {
  max-width: 100vw;
}

.intro--card {
  max-width: 100vw;
  border-radius: 50%;
}

.intro--text-title {
  font-family: "Concert One", cursive;
  /* color: rgb(220, 171, 209); */
  color: black;
  line-height: 1.2;
}

.intro--text-body {
  font-family: "Avenir", cursive;
  line-height: 1.6;
  color: rgb(0, 0, 0);
  text-align: left;
}
/* Exp Carousel Section */
.exp-title {
  font-family: "Concert One", cursive;
  /* color: rgb(220, 171, 209); */
  color: black;
  line-height: 1;
  text-align: center;
}

/*  <!-- rgba(244, 219, 232, 0.57) --> */
/* fccbd3 */
.exp--text-container {
  /* background-color: rgba(244, 219, 232, 0.57); */
  background-color: white;
}

.exp-desc {
  font-family: "Avenir", cursive;
  line-height: 1.6;
  color: rgb(18, 15, 15);
  text-align: left;
}

.exp-iframe {
  -ms-transform: translateY(0.75);
  -webkit-transform: translateY(0.75);
  -moz-transform: translateY(0.75);
  -o-transform: translateY(0.75);
  transform: translateY(0.75);
  zoom: 0.75;
}

.exp-subtitle {
  font-family: "Avenir", cursive;
  line-height: 1.6;
  color: rgb(65, 64, 64);
  text-align: center;
}

.exp-when {
  font-family: "Avenir", cursive;
  line-height: 1.6;
  color: white;
  text-align: center;
}

.exp-iframe {
  zoom: 0.75;
}

/* Project Tiles */
.pt--text-style {
  font-family: "Avenir", cursive;
  line-height: 1.6;
  text-align: left;
}

.pt--card-title {
  font-family: "Concert One", cursive;
  text-align: center;
  line-height: 1.1;
}

/* Contact Section */
.contact--text {
  font-family: "Avenir", cursive;
  line-height: 1.6;
  text-align: left;
}

.contact--heading {
  font-family: "Concert One", cursive;
  text-align: center;
  line-height: 1.2;
}

/* Containers */
.custom--container {
  max-width: "100%";
  position: relative;
  height: 100vh;
}

/* Formatting */

.v-btn::before {
  background-color: rgba(250, 164, 208, 0.831);
}

.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

/* Timeline */
.timeline--connector {
  border-left: 3px solid #fccbf5;
  /* standard height */
  height: 20vh;
  width: 0.5vh;
  margin-bottom: 0vh;
}

.timeline--node {
  width: 4vh;
  border-radius: 50%;
  height: 4vh;
  background-color: #fccbf5;
  margin-bottom: 0vh;
  text-align: center;
  cursor: pointer;
}

.timeline--node-label {
  text-align: center;
}

.scroll-helper {
  position: fixed;
}

/* FOR VARYING FONT SIZE DEPENDING ON VIEWPORT SIZE */
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .pt--card-title {
    font-size: 1.3rem;
  }
  .pt--text-style,
  .exp-when,
  .exp-subtitle,
  .exp-desc {
    font-size: 0.5rem;
  }

  .contact--heading {
    font-size: 1.5rem;
  }

  .contact--text {
    font-size: 0.7rem;
  }

  .exp-title {
    font-size: 2rem;
  }

  .about--text-name {
    font-size: 3rem;
  }

  .about--text-body {
    font-size: 1rem;
  }

  .intro--text-body {
    font-size: 0.9rem;
  }

  .pt--card-actions {
    display: none;
  }

  .pt--card-tag-container {
    display: none;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .pt--card-title {
    font-size: 1.5rem;
  }

  .pt--text-style,
  .exp-when,
  .exp-subtitle,
  .exp-desc {
    font-size: 1rem;
  }

  .exp-title {
    font-size: 3rem;
  }

  .contact--heading {
    font-size: 2rem;
  }

  .contact--text {
    font-size: 1rem;
  }

  .about--text-name {
    font-size: 3.5rem;
  }

  .about--text-body {
    font-size: 1.1rem;
  }

  .intro--text-body {
    font-size: 1rem;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .pt--card-title {
    font-size: 1.5rem;
  }

  .pt--text-style,
  .exp-desc,
  .exp-subtitle,
  .exp-when {
    font-size: 1rem;
  }

  .exp-title {
    font-size: 3rem;
  }

  .contact--heading {
    font-size: 2rem;
  }

  .contact--text {
    font-size: 1.5rem;
  }

  .about--text-name {
    font-size: 4rem;
  }

  .about--text-body {
    font-size: 1.5rem;
  }

  .intro--text-body {
    font-size: 1rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .pt--card-title {
    font-size: 2rem;
  }

  .pt--text-style,
  .exp-desc,
  .exp-subtitle,
  .exp-when {
    font-size: 1rem;
  }

  .exp-title {
    font-size: 3rem;
  }

  .contact--heading {
    font-size: 3rem;
  }

  .contact--text {
    font-size: 2rem;
  }

  .about--text-name {
    font-size: 5rem;
  }

  .about--text-body {
    font-size: 1.8rem;
  }

  .intro--text-body {
    font-size: 1.1rem;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .pt--card-title .intro--text-body {
    font-size: 1.8rem;
  }

  .pt--text-style,
  .exp-desc,
  .exp-subtitle,
  .exp-when {
    font-size: 1rem;
  }

  .contact--heading,
  .exp-title {
    font-size: 4rem;
  }

  .contact--text {
    font-size: 2rem;
  }

  .about--text-name {
    font-size: 6rem;
  }

  .about--text-body,
  .intro--text-title {
    font-size: 1.8rem;
  }

  .intro--text-body {
    font-size: 1.2rem;
  }
}

/* dusty pastel colour palette
#eddcdc
#eae5d8
#d7ead2
#cee8e4
#c6d5e0

sky blue
#cfebfd
*/
</style>
